module.exports = __webpack_public_path__ + "static/media/discount-white.ec87f0dc.png";